export default "__VITE_ASSET__CgyN2ym1__"